import * as React from 'react';
import { SVGProps } from 'react';

const CircleCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    style={{
      color: 'var(--x-default-color-accent)',
    }}
    viewBox="0 0 50 50"
    {...props}>
    <path
      strokeWidth={2}
      d="M49 25c0 13.255-10.745 24-24 24S1 38.255 1 25 11.745 1 25 1s24 10.745 24 24Z"
    />
    <path
      strokeWidth={2}
      d="m15 24.511 7.307 7.307L35.125 19"
      style={{
        stroke: 'currentcolor',
      }}
    />
  </svg>
);
export default CircleCheck;
